import React from "react";
import createReactClass from "create-react-class";

import PhotoDeletebutton from "./photo_delete_button";
import PhotoFaceMaskbutton from "./photo_face_mask_button";

export default createReactClass({
  displayName: "Root",
  getPhotoDirection() {
    var direction = this.props.photo.is_wide ? "photo-w" : "photo-h";
    return direction;
  },
  handlePhotoItem() {
    this.props.openModal(this.props.index);
  },
  getInitialState() {
    return {
      display: "none",
      direction: "photo-w",
    };
  },
  componentDidMount() {
    this.setState({
      direction: this.getPhotoDirection(this.props.photo.safe_image),
    });
  },
  render() {
    return (
      <li className="col-md-3 col-sm-3 col-xs-4 photo-list" data-cat="1">
        <a className="photo-wrap">
          <PhotoDeletebutton
            photoId={this.props.photo.id}
            isActive={this.props.isPhotoDeletebuttonActive}
            deletePhotoSelected={this.props.deletePhotoSelected}
          />
          <PhotoFaceMaskbutton
            photoId={this.props.photo.id}
            isActive={this.props.isFaceMaskButtonActive}
            faceMaskPhotoSelected={this.props.faceMaskPhotoSelected}
            index={this.props.index}
          />
          <span onClick={this.handlePhotoItem}>
            <img
              className={this.state.direction}
              src={this.props.photo.safe_image}
            />
          </span>
        </a>
      </li>
    );
  },
});
